import { Menu, X } from "lucide-react";
import NavbarBrand from "./navbar/NavbarBrand";
import DesktopNav from "./navbar/DesktopNav";
import MobileNav from "./navbar/MobileNav";
import useNavbarState from "./navbar/useNavbarState";

export default function Navbar() {
  const { open, toggleOpen, openKey, setOpenKey, mobileKey, toggleMobileKey } = useNavbarState();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-white border-b border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between h-16">
        <NavbarBrand />
        <DesktopNav openKey={openKey} setOpenKey={setOpenKey} />
        <button
          data-testid="mobile-menu-toggle"
          onClick={toggleOpen}
          className="xl:hidden inline-flex items-center justify-center rounded-sm border border-slate-300 h-9 w-9 text-slate-700"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && <MobileNav mobileKey={mobileKey} toggleMobileKey={toggleMobileKey} />}
    </header>
  );
}
